import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PlatformLocation } from "@angular/common";

@Component({
    selector: "app-help-modal",
    templateUrl: "./help-modal.component.html",
    styleUrls: ["./help-modal.component.scss"],
    standalone: false,
})
export class HelpModalComponent {
    constructor(
        public activeModal: NgbActiveModal,
        private location: PlatformLocation,
    ) {
        location.onPopState(() => activeModal.close());
    }
}
